import { FormEvent } from 'react';
import { Button, ButtonGroup, Col, ControlLabel, Form, FormGroup, Row, Well, FormControl } from 'react-bootstrap';
import { ICenterBase, ICenterFiveStarSurveyType } from '@nkr/models/index';

interface IProps {
    startDate: string,
    endDate: string,
    isAdmin: boolean,
    centerId: number,
    includeDash: boolean,
    includeNkr: boolean,
    centerList: ICenterBase[],
    onChange: (property: string) => void,
    onFilterChange: (startDate: string, endDate: string, centerId: number,) => void
    onFilter: () => void
}

const Filter = (props: IProps) => {
    const handleIncludeChange = (e: React.FormEvent<HTMLButtonElement>) => {

        props.onChange(e.currentTarget.value);
    };

    const handleCenterChange = (e: React.ChangeEvent<FormControl & HTMLSelectElement>) => {
        let centerId = parseInt(e.currentTarget.value);

        props.onFilterChange(props.startDate, props.endDate, centerId);
    }

    return (
        <Well bsSize='sm'>
            <Row>
                <Col xs={12} lg={3}>
                    <ButtonGroup>
                        <button type='button' className={"btn " + (props.includeDash ? 'btn-primary active' : 'btn-default')} value='includeDash' onClick={handleIncludeChange}>DASH</button>
                        <button type='button' className={"btn " + (props.includeNkr ? 'btn-primary active' : 'btn-default')} value='includeNkr' onClick={handleIncludeChange}>NKR</button>
                    </ButtonGroup>
                </Col>

                {props.isAdmin && (
                    <Col xs={12} lg={2} style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ marginRight: 5 }}>Center:</div>
                        <FormControl
                            componentClass="select"
                            style={{ width: "initial" }}
                            value={props.centerId}
                            onChange={handleCenterChange}
                        >
                            <option value={0}>- ALL CENTERS -</option>
                            {props.centerList.map((center, index) =>
                                <option key={index} value={center.id}>{center.alias}</option>
                            )}
                        </FormControl>
                    </Col>
                )}

                <Col xs={12} lg={3} style={{ float: "right" }}>
                    <Button bsStyle='primary' style={{ width: '100%' }} onClick={props.onFilter}>Filter</Button>
                </Col>
            </Row>
        </Well>
    );
}

export default Filter;
